// src/ConsumerApp/Screens/Account/components/OrderCard.js
import React from 'react';
import { theme } from '../../../../assets/theme/theme';

// Real SVGs from assets/icons
import Truck from '../../../../assets/icons/Truck.svg';
import ClipboardText from '../../../../assets/icons/ClipboardText.svg';
import Stack from '../../../../assets/icons/Stack.svg';
import FileText from '../../../../assets/icons/FileText.svg';
import CaretRightRed from '../../../../assets/icons/CaretRightRed.svg';

export default function OrderCard({ order, onPress }) {
  // Status Config matching mobile OrderCard.js
  const getStatusConfig = (status) => {
    switch (status) {
      case 'Confirmed':
        return { bg: '#E8F5EE', color: '#1E8449', icon: Truck };
      case 'Quote received':
        return { bg: '#F9E4E2', color: '#E9001E', icon: ClipboardText };
      case 'Quotes received':
        return { bg: '#EBF4FF', color: '#1D4ED8', icon: Stack };
      case 'Delivered':
        return { bg: '#E8F5EE', color: '#1E8449', icon: Truck };
      default:
        return { bg: '#F5F3EF', color: '#636C78', icon: FileText };
    }
  };

  const statusName = order.salesorder_status || order.status || 'Confirmed';
  const statusConfig = getStatusConfig(statusName);
  const StatusIcon = statusConfig.icon;

  const formattedDate = (order.order_date || order.createdAt)
    ? new Date(order.order_date || order.createdAt).toLocaleString('en-IN', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      })
    : '--';

  const displayTitle =
    order.items && order.items.length > 0
      ? (order.items_count > 1 || order.items.length > 1)
        ? `${order.items[0].item_name || order.items[0].product_name} + ${(order.items_count || order.items.length) - 1} Item(s)`
        : order.items[0].item_name || order.items[0].product_name
      : order.productName || 'Order Items';

  const totalPrice = order.total || order.total_amount || order.price || '0';

  return (
    <div style={cardStyles.card} onClick={onPress}>
      {/* Top Section: Number, Status Tag, and Price */}
      <div style={cardStyles.cardTopRow}>
        <div style={cardStyles.tagsRow}>
          <span style={cardStyles.orderNumberText}>
            {order.order_number || order.salesorder_id || order._id}
          </span>

          <div style={{ ...cardStyles.statusTag, backgroundColor: statusConfig.bg }}>
            <img src={StatusIcon} alt="status" style={{ width: 12, height: 12 }} />
            <span style={{ fontSize: 11, color: statusConfig.color, fontWeight: '600' }}>
              {statusName}
            </span>
          </div>
        </div>

        <span style={cardStyles.priceText}>₹{Number(totalPrice).toLocaleString('en-IN')}</span>
      </div>

      {/* Timestamp */}
      <span style={cardStyles.dateText}>{formattedDate}</span>

      {/* Bottom Section: Title and Red Caret */}
      <div style={cardStyles.cardBottomRow}>
        <span style={cardStyles.productTitle} title={displayTitle}>
          {displayTitle}
        </span>
        <div style={cardStyles.caretButton}>
          <img src={CaretRightRed} alt="open" style={{ width: 14, height: 14 }} />
        </div>
      </div>
    </div>
  );
}

const cardStyles = {
  card: {
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    border: '0.5px solid #CBD5E1',
    padding: 16,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    cursor: 'pointer',
    boxSizing: 'border-box',
    transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
  },
  cardTopRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  tagsRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    flexWrap: 'wrap',
  },
  orderNumberText: {
    fontSize: 13,
    fontWeight: '700',
    color: '#2E4057',
  },
  statusTag: {
    display: 'inline-flex',
    alignItems: 'center',
    borderRadius: 999,
    padding: '4px 8px',
    gap: 4,
  },
  priceText: {
    fontSize: 13,
    fontWeight: '700',
    color: '#2B2A29',
  },
  dateText: {
    fontSize: 11,
    color: '#707B8C',
  },
  cardBottomRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 4,
  },
  productTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: '#2B2A29',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    flex: 1,
    marginRight: 16,
  },
  caretButton: {
    width: 22,
    height: 22,
    borderRadius: 11,
    backgroundColor: '#FFFFFF',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
  },
};